module.exports = __webpack_public_path__ + "assets/img/cw-logo.1876dda9.png";